// react
import CityPostListPage from "components/cities/CityPostListPage";

export default CityPostListPage;
